
<div *ngIf="isLoading" class="d-flex justify-content-center my-5">
  <div class="spinner-border text-warning" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>


<div class="mainDiv">
  <div class="row">
    <div class="mainTxt d-flex justify-content-center mt-3" style="color: #f3a43f; font-size: 48px; font-weight: 500">
      My Bookings
    </div>
    <div class="search_Div mt-4 d-flex justify-content-center mb-4">
      <div class="search-container">
        <input type="text" placeholder="Search" [(ngModel)]="searchText" (keyup)="getBookingList(searchText)" />
        <span class="search-icon">🔍</span>
      </div>
    </div>
  </div>
  <div *ngIf="!isLoading">
  <div class="card p-2">
    <div class="card-header">
      <h5>Bookings</h5>
      <!-- <div class="search-box">
        <input
          type="text"
          placeholder="Search"
          [(ngModel)]="searchText"
          (keyup)="getBookingList(searchText)"
        />
        <i class="fas fa-search"></i>
      </div> -->
    </div>
    <div class="table-responsive" *ngIf="bookingList?.length != 0">
      <table class="table table-borderless">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Event Name</th>
            <th>Event Date & Time</th>
            <th>No. of Kids</th>
            <th>Date of Bookings</th>
            <th>Amount Paid</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of bookingList; let i = index">
            <td>{{ this.pagelimit * this.currentPage + i + 1 }}</td>
            <td>{{ item?.choirName ? item?.choirName : "--" }}</td>
            <td>
              {{ convertSecondsToDate(item?.startDateInSeconds) }} ,
              {{ convertSecondsToTime(item?.startTimeInSeconds) }}
            </td>
            <td>{{ item?.numberOfKids ? item?.numberOfKids : "0" }}</td>
            <td>{{ convertSecondsToDate(item?.createdAt) }}</td>
            <td>${{ item?.totalAmount }}</td>
            <td #Btn (click)="OpenModal(userCheckoutScreen, Btn, item)">
              <img src="../../../../assets/images/info-circle.svg" style="cursor: pointer" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="noPage"
      *ngIf="bookingList?.length == 0"
      style="min-height: 200px; display: flex; justify-content: center; align-items: center"
    >
      <span class="noBookingTxt"> No booking Found</span>
    </div>
    <div class="totalPagintion d-flex">
      <div class="results-per-page">
        <span>Results per page: </span>
        <select
          class="form-control form-control-sm"
          style="width: 70px; margin-left: 10px"
          (change)="changePageLimit()"
          [(ngModel)]="pagelimit"
        >
          <option>5</option>
          <option>10</option>
          <option>15</option>
        </select>
      </div>
      <div class="col-md">
        <div class="form-group pagination mt-2" style="float: right">
          <div class="pagination">
            <div class="pagination-box" (click)="prevPage()" [ngClass]="{ disabled_pagination: currentPage == 0 }">
              <
            </div>
            <div class="pagination-box">{{ currentPage + 1 }} / {{ totalPage }}</div>
            <div
              class="pagination-box"
              (click)="nextPage()"
              [ngClass]="{
                disabled_pagination: currentPage + 1 == totalPage
              }"
            >
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <nav aria-label="Page navigation">
      <ul class="pagination">
        <li class="page-item"><a class="page-link" href="#">Previous</a></li>
        <li class="page-item"><a class="page-link" href="#">1</a></li>
        <li class="page-item"><a class="page-link" href="#">2</a></li>
        <li class="page-item"><a class="page-link" href="#">3</a></li>
        <li class="page-item"><a class="page-link" href="#">...</a></li>
        <li class="page-item"><a class="page-link" href="#">8</a></li>
        <li class="page-item"><a class="page-link" href="#">9</a></li>
        <li class="page-item"><a class="page-link" href="#">Next</a></li>
      </ul>
    </nav> -->
  </div>
</div>
</div>
<ng-template #userCheckoutScreen let-modal>
  <app-spinner *ngIf="isLoading1" [type]="'normal'"></app-spinner>

  <!-- Modal Header -->
  <div class="modal-header">
    <h5 class="modal-title">Summary</h5>
    <div class="crossIcon">
      <img
        src="../../../../assets/images/purple-cross.svg"
        style="cursor: pointer"
        data-dismiss="modal"
        (click)="closeModal('dismiss')"
      />
    </div>
  </div>

  <!-- Modal Body -->
  <div class="modal-body">
    <div class="summary-section">
      <table class="summary-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Age</th>
            <th>Gender</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of kidsDetail">
            <td>{{ item?.firstName ? item?.firstName : "--" }} {{ item?.lastName ? item?.lastName : "--" }}</td>
            <td>{{ item?.age ? item?.age : "--" }}</td>
            <td>{{ item?.gender ? item?.gender : "--" }}</td>
          </tr>
          <!-- <tr>
              <td>Kelly Jay</td>
              <td>15</td>
              <td>Male</td>
            </tr> -->
        </tbody>
      </table>
      <p class="paymentTxt">Booking Detail</p>
      <div class="payment-summary">
        <div class="summary-item">
          <span>Total</span>
          <span>${{ bookingDetail?.totalAmount - bookingDetail?.totalTaxes }}</span>
        </div>
        <div class="summary-item">
          <span>Taxes</span>
          <span>${{ bookingDetail?.totalTaxes }} </span>
        </div>
        <div class="summary-item grand-total">
          <span>Grand Total</span>
          <span>${{ bookingDetail?.totalAmount }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Footer -->
  <!-- <div class="modal-footer" style="justify-content: center">
      <button class="btn btn-Login" (click)="saveBooking()">
        Checkout <img src="../../../../assets/images/IconRightturn.svg" />
      </button>
    </div> -->
</ng-template>
